import BlogFortyContainer from "./container/BlogFortyContainer";
export default BlogFortyContainer;
